import { type ReactNode } from "react"

import { CoreTechStackLogos } from "@/brand/components/tech-stack-logos"
import { Heading } from "@/ui/typography"

interface HeroProps {
  title: string
  description: ReactNode
  cta: ReactNode
  badge?: ReactNode
  children?: ReactNode
}

export const Hero = ({ title, description, cta, badge, children }: HeroProps) => {
  return (
    <section className="relative flex min-h-screen xl:min-h-[905px]">
      {children}
      <div className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-6 px-4 py-20 md:gap-10">
        {badge}
        <Heading level={1} className="my-0 text-center text-5xl md:text-6xl">
          {title}
        </Heading>
        <p className="text-muted-foreground text-center text-xl leading-relaxed">{description}</p>
        <CoreTechStackLogos />
        <div className="flex items-center gap-4">{cta}</div>
      </div>
    </section>
  )
}
